module.exports = __webpack_public_path__ + "img/Bartek_C.c9b19180.jpg";